export default __webpack_public_path__ + "static/media/pneumatico.0fef8ae5.png";